import { type CSSProperties } from 'react';
import { Lock, Sparkles } from 'lucide-react';
import { useStore, countSubsystems, useReadOnly } from '../store';
import { FREE_LIMITS } from '../entitlements';
import { isBillingConfigured } from '../billing';

/**
 * Shown when a free account opens a project that exceeds the free plan (more
 * subsystems than allowed). The document is view-only until they upgrade — or
 * delete a subsystem to bring it back under the limit (deletion stays enabled).
 */
export function ReadOnlyBanner() {
  const readOnly = useReadOnly();
  const sheets = useStore((s) => s.sheets);
  if (!readOnly) return null;
  const count = countSubsystems(sheets);

  return (
    <div style={bar}>
      <Lock size={14} style={{ flexShrink: 0 }} />
      <span style={{ flex: 1, minWidth: 0 }}>
        <strong>Read-only.</strong> This project has {count} subsystems — the Free plan allows{' '}
        {FREE_LIMITS.subsystems}. Upgrade to edit, or delete a subsystem to fit the Free plan.
      </span>
      {isBillingConfigured && (
        <button
          style={btn}
          onClick={() => window.dispatchEvent(new CustomEvent('skema:open-upgrade'))}
        >
          <Sparkles size={13} /> Upgrade to Pro
        </button>
      )}
    </div>
  );
}

const bar: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '7px 14px',
  fontSize: 12.5,
  lineHeight: 1.4,
  color: 'var(--text)',
  background: 'var(--accent-soft, rgba(59,130,246,0.12))',
  borderBottom: '1px solid var(--accent-border, var(--accent))',
};
const btn: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  flexShrink: 0,
  border: 'none',
  borderRadius: 'var(--radius-sm)',
  background: 'var(--accent)',
  color: '#fff',
  fontSize: 12,
  fontWeight: 800,
  padding: '6px 12px',
  cursor: 'pointer',
};
